module.exports = __webpack_public_path__ + "static/media/reiki-seminars.7f78210b.png";